export default [
  {
    path: '/playlists',
    name: 'playlists',
    component: () => import('../../views/playlists/playlists.vue'),
    meta: {
      pageTitle: 'Playlists',
      breadcrumbs: ['Playlists'],
    },
    children: [
      {
        path: '',
        name: 'playlists-list',
        component: () => import('../../views/playlists/list.vue')
      },
      {
        path: 'create',
        name: 'playlists-create',
        component: () => import('../../views/playlists/create.vue'),
        meta: {
          pageTitle: 'Create Playlist',
          breadcrumbs: ['Playlists', 'Create'],
        }
      },
      {
        path: ':id/edit',
        name: 'playlists-edit',
        component: () => import('../../views/playlists/edit.vue'),
        meta: {
          pageTitle: 'Edit Playlist',
          breadcrumbs: ['Playlists', 'Edit'],
        }
      },
    ]
  },
  {
    path: '/tracks',
    name: 'tracks',
    component: () => import('../../views/tracks/tracks.vue'),
    meta: {
      pageTitle: 'Tracks',
      breadcrumbs: ['Playlists', 'Tracks'],
    },
    children: [
      {
        path: '',
        name: 'tracks-list',
        component: () => import('../../views/tracks/list.vue')
      },
      {
        path: ':id/edit',
        name: 'tracks-edit',
        component: () => import('../../views/tracks/edit.vue'),
        meta: {
          pageTitle: 'Edit Track',
          breadcrumbs: ['Tracks', 'Edit'],
        }
      },
    ]
  },
]
